export default __webpack_public_path__ + "static/media/TagandTrace_logo.d78cdb4a.png";